import { gql } from '@apollo/client';

import { useLazyQuery } from 'api';
import permissions from 'api/Apollo/permissions';

export const PIPELINE_INTEGRATION_ATTACHMENT_QUERY = 'PipelineIntegrationAttachment';

export const GET_PIPELINE_INTEGRATION_ATTACHMENT = gql`
  query ${PIPELINE_INTEGRATION_ATTACHMENT_QUERY}($pipelineId: uuid!, $integrationId: uuid!) {
    pipelines_by_pk(id: $pipelineId) {
      id
      writekey
      cluster {
        id
        name
      }
      pipelineIntegrations: pipeline_integrations(
        where: { integrationId: { _eq: $integrationId }, deletedAt: { _is_null: true } }
      ) {
        id
        disabled
        stagedRevision: staged_revision {
          id
          pipelineVars
        }
        pipelineIntegrationConsent: pipeline_integration_consent {
          id
          mode
          consentCategory: consent_category {
            id
            code
            name
          }
        }
      }
    }
  }
`;

export default function useLazyQueryPipelineIntegrationAttachment(options = {}) {
  const [executeQuery, { data, isAllowed, loading, error, ...rest }] = useLazyQuery(
    GET_PIPELINE_INTEGRATION_ATTACHMENT,
    {
      fetchPolicy: 'network-only',
      nextFetchPolicy: 'cache-and-network',
      context: { permission: permissions.readPipeline },
      ...options,
    }
  );

  const getPipelineIntegrationAttachment = ({ pipelineId, integrationId }) => {
    const variables = { pipelineId, integrationId };
    return executeQuery({ variables });
  };

  const pipeline = data?.pipelines_by_pk ?? null;

  return [
    getPipelineIntegrationAttachment,
    {
      pipeline,
      attachment: pipeline?.pipelineIntegrations[0] ?? null,
      loading,
      isAllowed,
      error,
      ...rest,
    },
  ];
}
